<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-1">
<div class="heading heading-with-title heading-without-image" id="chapter-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Chapter One</h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-1-text">
<div class="blockquote-container prose without-attribution">
<blockquote class="prose without-attribution">
<div class="blockquote-image-block blockquote-image-aspect-wide">
<div class="blockquote-image-size-container">
<img alt="" class="blockquote-image-image" src="images/blockquote-big-66-screen.png"/>
</div>
</div>
<p class="first blockquote-content blockquote-content-prose blockquote-position-first"><i>All stories are about wolves. Anything else is sentimental drivel.</i></p>
<p class="subsq blockquote-content blockquote-content-prose blockquote-position-last"><span class="smallcaps">~ Margaret Atwood</span></p>
</blockquote>
</div>
<p class="first first-in-chapter first-full-width first-after-blockquote"><span class="smallcaps"><span class="first-phrase">Morgan Ames had died.</span></span> There was no arguing that. The only fact currently under debate was: exactly how many times?</p>
<p class="subsq">One of the nurses helping to change Morgan’s bed insisted the chart said three: twice in the ER and once more in the OR. His breath smelled of chili peppers and onions as he rolled Morgan’s lifeless body toward him and hugged her close to allow the other aide to wad up the bottom sheet and shove it below Morgan’s hips.</p>
<p class="subsq">The second nurse then rolled Morgan toward her, overtop the heap of soiled bedding. Her breath was minty toothpaste. Her arms were strong against Morgan’s limp limbs, but there was nothing affectionate in her embrace. Morgan was simply one more chore to be crossed off a list before end of her shift.</p>
<p class="subsq">“Four,” she argued. Somewhere in the avalanche of memory that kept Morgan buried, she knew the woman was talking about her, but it was as if everyone—including Morgan, or the girl who had once been Morgan—was so far away, they could have been on the dark side of the moon. It had nothing to do with Morgan; certainly it wasn’t as important as clean sheets with no wrinkles to irritate and rub bedsores into her motionless, dead-weight body. “You’re forgetting she had no vitals at the scene. Still can’t believe she flew an ATV off the side of a mountain to take out a serial killer. Must’ve been a brave kid once upon a time.”</p>
<p class="subsq">“Or stupid,” the man answered. “Besides, that first time doesn’t count—she was hypothermic. You’re not dead until you’re warm and dead.”</p>
<p class="subsq">With brisk motions, they tucked the sheet below the mattress, turned on the air jets that made Morgan float and prevented bedsores, and moved on to the next bed in the ward with its own not-quite-dead, not-quite-alive occupant.</p>
<p class="subsq">Morgan never did learn how many times she’d died before the avalanche buried her deep in a grave filled with white static and pain.</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width"><span class="smallcaps"><span class="first-phrase">As Morgan drifted</span> in a place </span>where time was meaningless, she tried to create a list of what she knew for certain. Facts. Road signs to guide her back to her life.</p>
<p class="subsq"><span class="smallcaps">1. Fact:</span> She’d died. Get over it.</p>
<p class="subsq"><i>2. Fact: </i>She was in a coma but the nurse was excited because she’d now moved into a “minimally responsive state” …words were weird… people were weird… why did they keep poking her and then clapping when she swatted them away?</p>
<p class="subsq"><b>G. </b>There were numbers more than two but they floated out of reach.</p>
<p class="subsq">Zelda. Her nose itched and she couldn’t scratch it. Was this hell?</p>
<p class="subsq">% Given what little she remembered of her life, she definitely deserved to be in hell.</p>
<p class="subsq"><b>42.</b> Her father was dead. And rotting in hell.</p>
<p class="subsq"><i>?</i> So maybe she wasn’t in hell since he wasn’t here with her.</p>
<p class="subsq">! No hell could be worse than an itch she couldn’t scratch.</p>
<p class="subsq"><i>R.</i> There was a fly buzzing near her eyes. Sticky goop made her eyelids itchy, too.</p>
<p class="subsq">&gt; Micah brought sweet smells when he came to visit. Hmmm…so nice.</p>
<p class="subsq">@ She more than liked Micah.</p>
<p class="subsq">&amp; Micah knew to swat the fly, wipe the goop, and scratch her nose for her.</p>
<p class="subsq"><span class="smallcaps">Coda.</span> Micah left and the world turned cold, the avalanche tumbling her back down into oblivion.</p>
<p class="subsq">FACT. People dug themselves free of avalanches.</p>
<p class="subsq"><i>Fact + Secret &amp; Fear - Powerless = Need:</i> Someone was hurting the patients here.</p>
<p class="subsq"><b># Query *</b> Was she next?</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter001.vue?382aaeca